import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: ${props => props.theme.width.widthMain};
  margin: 0 auto;
  padding: 1rem;
  background-color: ${props => props.theme.colors.primary};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Heading = styled.h1`
  font-size: 2rem;
  color: ${props => props.theme.colors.secondary};
`;

export const RadioTable = styled.table`
  width: 100%;
  margin-bottom: 1rem;

  tr {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.5rem;

    td {
      display: flex;
      align-items: center;

      input[type='radio'] {
        margin-right: 0.5rem;
      }

      .pricing {
        font-weight: bold;
        color: ${props => props.theme.colors.tertiary};
      }
    }
  }
`;

export const Input = styled.input`
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid ${props => props.theme.colors.secondary};
`;

export const Select = styled.select`
  width: 100%;
  padding: 0.5rem;
  margin-bottom: 1rem;
  border: 1px solid ${props => props.theme.colors.secondary};
`;

export const Button = styled.button`
  padding: 0.5rem 1rem;
  background-color: ${props => props.theme.colors.secondary};
  color: ${props => props.theme.colors.labelButton};
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${props => props.theme.colors.fourth};
  }
`;
